module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame1.22f1a1a6.png";